import { Option } from 'funfix-core';
import React from 'react';
import { ANALYTICS_MODAL_CUSTOM_INSTALL } from '../../../../analytics/Sources';
import { foldInstallStatus, isInstallStatusLoading } from '../../../../records/InstallMode/InstallStatus';
import { getErrorDetails } from '../../../../utils/request-utils';
import DialogCustomContainer from '../common/DialogCustomContainer';
import ExternalMarketplaceLink from '../common/ExternalMarketplaceLink';
import InstallableAppAlreadyInstalledMessage from '../common/InstallableAppAlreadyInstalledMessage';
import InstallableAppFooter from '../common/InstallableAppFooter';
import InstallableAppPrivacyInformation from '../common/InstallableAppPrivacyInformation';
import DialogInstallByManualUrlContent from './DialogInstallByManualUrlContent';
const resolveDialogInstallByManualUrl = _ref => {
  let {
    clearInstallableAppByManualUrl,
    closeInstallDialog,
    context,
    fetchInstallableAppByManualUrl,
    hostConfig,
    hostInfo,
    installableAppByManualUrlInstallMode,
    installApp,
    links,
    openManualUrlInstallDialog,
    openAppSpecificPasswordDialog,
    scopesLookup,
    featureFlags
  } = _ref;
  const fetchInstallableAppErrorDetails = installableAppByManualUrlInstallMode.installableAppByManualUrl.flatMap(iabmu => iabmu.installableApp.flatMap(ia => ia.swap().map(error => getErrorDetails(error, hostConfig, {
    showCustomBackendErrorsFromUpm: featureFlags.showCustomBackendErrorsFromUpm
  })).toOption()));
  return {
    analyticsSourceModal: ANALYTICS_MODAL_CUSTOM_INSTALL,
    content: /*#__PURE__*/React.createElement(DialogCustomContainer, {
      installMode: installableAppByManualUrlInstallMode,
      openManualUrlInstallDialog: openManualUrlInstallDialog,
      openAppSpecificPasswordDialog: openAppSpecificPasswordDialog
    }, /*#__PURE__*/React.createElement(DialogInstallByManualUrlContent, {
      context: context,
      clearInstallableAppByManualUrl: clearInstallableAppByManualUrl,
      fetchInstallableAppByManualUrl: fetchInstallableAppByManualUrl,
      fetchInstallableAppErrorDetails: fetchInstallableAppErrorDetails,
      hostConfig: hostConfig,
      installableAppByManualUrlInstallMode: installableAppByManualUrlInstallMode,
      links: links,
      scopesLookup: scopesLookup
    })),
    heading: 'Custom app',
    footerLeft: installableAppByManualUrlInstallMode.installableAppByManualUrl.flatMap(iabmu => iabmu.installableApp).flatMap(ia => ia.toOption()).map(installableApp =>
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-key
    React.createElement(ExternalMarketplaceLink, {
      context: context,
      links: links,
      marketplaceAppDetails: installableApp.marketplaceAppDetails
    })).getOrElse(),
    footerCenter: installableAppByManualUrlInstallMode.installableAppByManualUrl.flatMap(iabmu => iabmu.installableApp.flatMap(ia => ia.toOption()).map(ia =>
    // eslint-disable-next-line react/jsx-key
    iabmu.installedApp.fold(() => /*#__PURE__*/React.createElement(InstallableAppPrivacyInformation, {
      context: context,
      installableAppId: iabmu.installableAppByUrlId,
      marketplaceAppDetails: ia.marketplaceAppDetails
    }), () => /*#__PURE__*/React.createElement(InstallableAppAlreadyInstalledMessage, {
      hostConfig: hostConfig
    })))).getOrElse(),
    footerRight: /*#__PURE__*/React.createElement(InstallableAppFooter, {
      closeInstallDialog: closeInstallDialog,
      context: context,
      hostConfig: hostConfig,
      installApp: installApp,
      hostInfo: hostInfo,
      installableAppInstallMode: installableAppByManualUrlInstallMode,
      mpacBaseUrl: "mpacBaseUrl",
      isInstallInProgress: () => false // TODO: Delete unused DialogInstallByManualUrl
    }),
    preventDialogClosing: installableAppByManualUrlInstallMode.installableAppByManualUrl.exists(iabmu => isInstallStatusLoading(iabmu.status)),
    errorDetails: installableAppByManualUrlInstallMode.installableAppByManualUrl.flatMap(iabmu => foldInstallStatus(iabmu.status, () => Option.empty(), () => Option.empty(), complete => complete.result.fold(error => Option.some(getErrorDetails(error, hostConfig, {
      showCustomBackendErrorsFromUpm: featureFlags.showCustomBackendErrorsFromUpm
    })), () => Option.empty()))).orElseL(() => fetchInstallableAppErrorDetails.filter(ed => !ed.translation.validationError))
  };
};
export default resolveDialogInstallByManualUrl;